import { ActionIcon, Flex, Text } from '@mantine/core'
import { IconCircleXFilled } from '@tabler/icons-react'
import classes from './DataGridFilter.module.css'
import { FILTER_MODIFIERS } from '@constants/filterModifiers'

export interface DataGridFilterProps {
  column: string
  modifier: string
  value: string
  clearFilter: () => void
}

export const DataGridFilter = (props: DataGridFilterProps) => {
  const { column, modifier, value, clearFilter } = props

  return (
    <Flex className={classes.DataGridFilter} align="center">
      <Text size="sm" c="blue.9">
        <strong>{column}</strong>{' '}
        {FILTER_MODIFIERS.find((curr) => curr.value === modifier)?.label} "
        {value}"
      </Text>
      <ActionIcon variant="transparent" c="blue.9" onClick={clearFilter}>
        <IconCircleXFilled size={18} />
      </ActionIcon>
    </Flex>
  )
}
